import { useTranslation } from 'react-i18next';
import './TripBanner.css';

interface TripBannerProps {
    isTemplate: boolean;
    isPublic: boolean;
    isAuthenticated: boolean;
    cloning: boolean;
    onClone: () => void;
    onSignInToClaim: () => void;
}

export default function TripBanner({
    isTemplate,
    isPublic,
    isAuthenticated,
    cloning,
    onClone,
    onSignInToClaim
}: TripBannerProps) {
    const { t, i18n } = useTranslation();

    if (isTemplate) {
        return (
            <div className="template-banner">
                <div className="banner-content">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                    <span className="banner-text">
                        {t('trip.sample_itinerary')} — {t('trip.create_own_link')}
                    </span>
                </div>
                <div className="banner-actions">
                    <button
                        className="banner-btn customize-btn"
                        onClick={onClone}
                        disabled={cloning}
                    >
                        {cloning ? t('common.creating') : t('trip.customize_itinerary')}
                    </button>
                    <a href={i18n.language.split('-')[0] === 'en' ? '/' : `/${i18n.language.split('-')[0]}`} className="banner-link">{t('trip.create_new_scratch')}</a>
                </div>
            </div>
        );
    }

    if (isPublic) {
        return (
            <div className="public-banner">
                <div className="banner-content">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" />
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                    </svg>
                    <span className="banner-text">{t('trip.trip_is_public')}</span>
                </div>
                {!isAuthenticated && (
                    <div className="banner-actions">
                        <button className="banner-btn login-btn" onClick={onSignInToClaim}>{t('trip.sign_in_claim')}</button>
                    </div>
                )}
            </div>
        );
    }

    return null;
}
